var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    color: "#010109e6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-637b8d40f95e86b59c57a2cc-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roll_brush",
    "data-name": "roll brush"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    points: "8.14 17.8 5.26 14.92 8.14 12.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    points: "15.81 17.8 18.69 14.92 15.81 12.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    x1: 10.06,
    y1: 17.8,
    x2: 13.89,
    y2: 12.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    x: 1.43,
    y: 1.49,
    width: 21.1,
    height: 21.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    points: "22.53 7.25 16.25 7.25 14.33 7.25 1.43 7.25 1.43 1.49 22.53 1.49 22.53 7.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    x1: 4.3,
    y1: 4.37,
    x2: 6.22,
    y2: 4.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    x1: 8.14,
    y1: 4.37,
    x2: 10.06,
    y2: 4.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-637b8d40f95e86b59c57a2cc-1",
    x1: 11.98,
    y1: 4.37,
    x2: 13.89,
    y2: 4.37
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevIcon);
export default __webpack_public_path__ + "static/media/dev-icon.5c49fad04871d1675ec035d149b93d07.svg";
export { ForwardRef as ReactComponent };